// src/App.js
import React from 'react';

function App() {
  return (
    <div>
      <h1>Welcome to the Bias Detector</h1>
    </div>
  );
}

export default App;